document.addEventListener('DOMContentLoaded', function() {   
  const start = 943;
  const end = 695;
  const totalFrames = start - end + 1;
  const container = $("#jpegSequenceContainer");
  const img = $("#jpegFrame");
  const images = [
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0943.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0942.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0941.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0940.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0939.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0938.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0937.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0936.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0935.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0934.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0933.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0932.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0931.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0930.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0929.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0928.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0927.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0926.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0925.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0924.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0923.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0922.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0921.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0920.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0919.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0918.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0917.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0916.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0915.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0914.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0913.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0912.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0911.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0910.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0909.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0908.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0907.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0906.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0905.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0904.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0903.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0902.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0901.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0900.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0899.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0898.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0897.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0896.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0895.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0894.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0893.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0892.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0891.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0890.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0889.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0888.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0887.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0886.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0885.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0884.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0883.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0882.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0881.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0880.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0879.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0878.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0877.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0876.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0875.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0874.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0873.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0872.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0871.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0870.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0869.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0868.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0867.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0866.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0865.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0864.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0863.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0862.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0861.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0860.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0859.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0858.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0857.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0856.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0855.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0854.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0853.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0852.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0851.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0850.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0849.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0848.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0847.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0846.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0845.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0844.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0843.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0842.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0841.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0840.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0839.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0838.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0837.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0836.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0835.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0834.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0833.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0832.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0831.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0830.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0829.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0828.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0827.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0826.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0825.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0824.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0823.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0822.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0821.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0820.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0819.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0818.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0817.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0816.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0815.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0814.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0813.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0812.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0811.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0810.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0809.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0808.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0807.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0806.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0805.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0804.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0803.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0802.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0801.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0800.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0799.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0798.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0797.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0796.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0795.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0794.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0793.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0792.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0791.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0790.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0789.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0788.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0787.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0786.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0785.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0784.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0783.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0782.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0781.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0780.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0779.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0778.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0777.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0776.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0775.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0774.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0773.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0772.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0771.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0770.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0769.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0768.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0767.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0766.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0765.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0764.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0763.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0762.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0761.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0760.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0759.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0758.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0757.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0756.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0755.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0754.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0753.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0752.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0751.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0750.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0749.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0748.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0747.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0746.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0745.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0744.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0743.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0742.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0741.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0740.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0739.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0738.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0737.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0736.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0735.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0734.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0733.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0732.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0731.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0730.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0729.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0728.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0727.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0726.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0725.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0724.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0723.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0722.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0721.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0720.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0719.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0718.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0717.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0716.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0715.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0714.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0713.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0712.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0711.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0710.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0709.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0708.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0707.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0706.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0705.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0704.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0703.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0702.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0701.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0700.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0699.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0698.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0697.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0696.jpg',
  'https://cdn.shopify.com/s/files/1/0266/1302/2766/files/explode_0695.jpg'
]

  img.attr("src", images[0]);

  const wrapper = $("#jpegSequenceWrapper");
  const frameDelay = 60;
  let lastFrame = -1;
  let lastUpdate = 0;

  $(window).on("scroll", function () {
    const now = Date.now();
    if (now - lastUpdate < frameDelay) return;
    lastUpdate = now;

    const scrollTop = $(window).scrollTop();
    const wrapperTop = wrapper.offset().top;
    const wrapperHeight = wrapper.outerHeight();
    const progressRaw =
      (scrollTop - wrapperTop) / (wrapperHeight - window.innerHeight);
    const progress = Math.min(Math.max(progressRaw, 0), 1);
    const frameIndex = Math.floor(progress * (totalFrames - 1));

    if (frameIndex !== lastFrame) {
      img.attr("src", images[frameIndex]);
      lastFrame = frameIndex;
    }

    // Stickiness handled by CSS; no need to change position manually
  });
});